<template>
  <ReportsList/>
</template>
<script>
import ReportsList from '@/components/modules/schoolroutes/reports/list'
export default {
  name: 'reports',
  components: {
    ReportsList
  }
}
</script>



// WEBPACK FOOTER //
// src/views/schoolroutes/reports/list.vue